
import CustomActivatorSelect from '@root/src/components/inputs/CustomActivatorSelect.vue'
import TextField from '@root/src/components/inputs/TextField.vue'
import Vue, { PropType } from 'vue'
import difference from 'lodash/difference'
import cloneDeep from 'lodash/cloneDeep'
import { getServiceList } from '@root/src/api/chisai/GCB2'
import { Project } from '@root/src/types/main'
import { editAdditionalServices, getAdditionalServices } from '@root/src/api/networkFixer'

export default Vue.extend({
    name: "AdditionalServicesModal",
    components: { TextField,CustomActivatorSelect },
    props: {
        value: { type: Boolean as PropType<boolean> },
    },
    data: () => ({
        serviceList: [] as any[],
        selected: [] as any[],
        startSelected: [] as any[],
        selectedFromRes: [] as any,
        firstOpen: false as boolean
    }),
    computed: {
        project(): Project {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        isDialog: {
            get(): boolean {
                return this.value
            },
            set(value: boolean): void {
                this.$emit('input', value)
            },
        },
        diff(): { added: any[]; deleted: any[] } {
            const selectedIds = this.selected.map(el => el.id);
            const startSelectedIds = this.startSelected.map(el => el.id);
            
            return {
                added: this.selected.filter(el => !startSelectedIds.includes(el.id)),
                deleted: this.startSelected.filter(el => !selectedIds.includes(el.id)),
            }
        },
        selectedIds: {
            get(): any[] {
                return this.selected.map(el => el.id)
            },
            set(value: string[]): void {
                const currendAddedId = difference(value, this.selectedIds)
                const selectedCopy = [...this.selected]
                if (currendAddedId.length !== 0) {
                    const addEl: any = this.serviceList?.find(el => el.id === currendAddedId[0])
                    selectedCopy.push(addEl)
                    this.selected = [...selectedCopy]
                } else {
                    const currendDelId = difference(this.selectedIds, value)
                    const selectedNew = selectedCopy?.filter(el => el.id !== currendDelId[0])
                    this.selected = [...selectedNew]
                }
                
                
            },
        },
        textFieldString(): string {
            if (this.selected && this.selected?.length === 1) {
                return `${this.selected[0]?.name}`
            } else if (this.selected && this.selected?.length > 1) {
                return `${this.selected[0]?.name} (+${this.selected?.length - 1})`
            } else {
                return null
            }
            
        },
        selectedChanged(): boolean {
            return Boolean(this.diff.added?.length || this.diff.deleted?.length)
        },
        saveButtonText(): string {
            if(this.firstOpen) {
                return 'Завершить'
            } else {
                return 'Сохранить'
            }
        }
    },
    methods: {
        async closeModal() {
            if(this.firstOpen) {
                this.firstOpen = false
                await editAdditionalServices({projectId: this.project.id, services: [{type: 'firstRequest'}]})
            }
            this.selected = cloneDeep(this.startSelected)
            this.isDialog = false            
        },
        delService(id) {
            const filteredSelected = this.selected.filter(el => el.id !== id)
            this.selected = filteredSelected
        },
        async saveChange() {
            const arrToSave = []
            if(this.diff.added?.length > 0) {
                this.diff.added.forEach(el => {
                    const elToSave = {
                        id: Number(el.id) ? Number(el.id) : el.id,
                        name: el.name,
                        type: 'add'
                    }
                    arrToSave.push(elToSave)
                })
            }
            if(this.diff.deleted?.length > 0) {
                this.diff.deleted.forEach(el => {
                    const elToSave = {
                        id: Number(el.id) ? Number(el.id) : el.id,
                        name: el.name,
                        type: 'remove'
                    }
                    arrToSave.push(elToSave)
                })
            }
            if (this.firstOpen) {
                arrToSave.push({type: 'firstRequest'})
            }
            const [data, error] = await editAdditionalServices({projectId: this.project.id, services: arrToSave}).then(d => [d.data, d.error])
            if (error) {
                this.$store.dispatch('callNotify', 'При сохранении данных произошла ошибка')
                return
            } else {
                this.$store.dispatch('callNotify', 'Данные успешно сохранены')
            }
            await this.init()
            this.closeModal()
        },
        async init () {
            const [data, error] = await getServiceList({ projectId: this.project.id }).then(d => [d.data, d.error])
            if(error) {
                this.$store.dispatch('callNotify', 'При загрузке данных произошла ошибка')
                return
            }
            this.serviceList = data
            const resAddditionalServices = await getAdditionalServices({projectId: this.project.id})
            if (resAddditionalServices?.error) {
                this.$store.dispatch('callNotify', 'При загрузке данных произошла ошибка')
                return
            }
            this.selectedFromRes = resAddditionalServices
            this.selected = this.serviceList.filter(el => resAddditionalServices.data?.additionalServices?.some(el2 => el2.service_id === el.id))
            this.startSelected = cloneDeep(this.selected)
            if(resAddditionalServices?.data?.isFirstRequest) {
                this.firstOpen = true
            }
        }
    },
    async mounted() {
        await this.init()
        if(this.firstOpen) {
            this.isDialog = true
        }
    },
})
